import defaultAvatar from "@/assets/avatars/default.png";
import type { GameState, PlayerColor } from "@nextgammon/shared";
import { PLAYER_COLORS, TYPOGRAPHY } from "../constants/uiConstants";
import "../styles/player-info.css";
import { PipCounter } from "./PipCounter";

interface PlayerInfoProps {
  username: string;
  isCurrentTurn: boolean;
  playerColor: "white" | "black";
  isCurrentUser: boolean;
  userId: string;
  canAffordDouble?: boolean;
  gameState: GameState | null;
}

export function PlayerInfo({
  username,
  isCurrentTurn,
  playerColor,
  isCurrentUser,
  userId,
  canAffordDouble,
  gameState
}: PlayerInfoProps) {
  return (
    <div
      className={`
        player-card
        ${isCurrentTurn ? "player-card--active" : ""}
        ${isCurrentUser ? "mt-auto" : ""}
        ${isCurrentUser ? "" : "opacity-85"}
      `}
      data-user-id={userId}
    >
      <div className="player-main-row">
        <div
          className={`
          avatar-frame-compact
          ${isCurrentTurn ? "avatar-frame--active" : ""}
        `}
        >
          <img
            src={defaultAvatar}
            alt={`${username}'s avatar`}
            className="avatar-image"
            onError={(e) => {
              (e.target as HTMLImageElement).src = "/assets/default-avatar.png";
            }}
          />
          {/* Color indicator badge */}
          <div
            className="absolute -top-1 -right-1 w-3 h-3 rounded-full border-2"
            style={{
              backgroundColor:
                playerColor === "white"
                  ? PLAYER_COLORS.WHITE_INDICATOR_BG
                  : PLAYER_COLORS.BLACK_INDICATOR_BG,
              borderColor:
                playerColor === "white"
                  ? PLAYER_COLORS.WHITE_INDICATOR_BORDER
                  : PLAYER_COLORS.BLACK_INDICATOR_BORDER
            }}
          ></div>
        </div>
        <div className="player-info-text">
          <div className="player-name-banner-compact banner--standard">
            <span className="player-name">{username}</span>
          </div>
          <div className="game-info-row">
            <PipCounter gameState={gameState} playerColor={playerColor as PlayerColor} />
            {canAffordDouble && (
              <span
                className="cube-icon font-bold"
                style={{
                  fontSize: `${TYPOGRAPHY.CUBE_ICON_SIZE}px`,
                  color: PLAYER_COLORS.CUBE_ICON_COLOR
                }}
              >
                □
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
